import { SkillBookGlobalStateInterface, ValidationErrors } from "../types";

export const validateStep1 = (
  state: SkillBookGlobalStateInterface,
): ValidationErrors => {
  let errors: ValidationErrors = {};
  if (!state.usersIdList || state.usersIdList.length === 0) {
    errors.user_id = "required_user_id";
  }
  return errors;
};

export const validateStep2 = (
  state: SkillBookGlobalStateInterface,
): ValidationErrors => {
  let errors: ValidationErrors = {};
  const today = new Date();
  const startDate = new Date(state.start_date);
  const endDate = new Date(state.end_date);
  const validationStartDate = new Date(state.validation_start_date);
  const validationEndDate = new Date(state.validation_end_date);

  if (!state.title) {
    errors.title = "required_certificate_title";
  }
  if (!state.duration) {
    errors.duration = "required_course_duration";
  }
  if (!state.start_date) {
    errors.start_date = "required_completion_start_date";
  }
  if (!state.source_id) {
    errors.source_id = "required_source_id";
  }
  if (!state.code) {
    errors.code = "required_code";
  }
  if (!state.end_date) {
    errors.end_date = "required_completion_end_date";
  }

  if (state.duration) {
    if (!state.duration) {
      errors.duration = "required_course_duration";
    } else if (isNaN(state.duration)) {
      errors.duration = "type_number_value_error";
    } else if (Number(state.duration) < 0) {
      errors.duration = "negative_value_error";
    }
  }

  if (state.durationParticipation) {
    if (isNaN(state.durationParticipation)) {
      errors.durationParticipation = "type_number_value_error";
    } else if (Number(state.durationParticipation) < 0) {
      errors.durationParticipation = "negative_value_error";
    }
  }

  if (startDate && startDate > today) {
    errors.start_date = "date_in_future_error";
  }

  if (endDate && endDate > today) {
    errors.end_date = "date_in_future_error";
  }

  if (endDate < startDate) {
    errors.end_date = "end_date_before_start_date";
  }

  if (validationEndDate < validationStartDate) {
    errors.validation_end_date = "end_date_before_start_date";
  }

  if (validationEndDate < today) {
    errors.validation_end_date = "certificate_expired";
  }

  if (validationStartDate < endDate) {
    errors.validation_start_date = "validation_start_date_before_end_course";
  }

  if (state.replacesPlatformCourse && !state.replacedCourse) {
    errors.replacedCourse = "required_replaced_course";
  }

  return errors;
};

export const validateStep2Enrollments = (
  state: SkillBookGlobalStateInterface,
): ValidationErrors => {
  const errors: ValidationErrors = {};
  const today = new Date();

  const startDate = state.startDate ? new Date(state.startDate) : null;
  const endDate = state.endDate ? new Date(state.endDate) : null;

  // — titolo obbligatorio —
  if (!state.title?.trim()) {
    errors.title = "required_certificate_title";
  }

  // — durata obbligatoria, >= 0 —
  if (!state.durationMinutes) {
    errors.durationMinutes = "required_course_duration";
  } else if (isNaN(Number(state.durationMinutes))) {
    errors.durationMinutes = "type_number_value_error";
  } else if (Number(state.durationMinutes) < 0) {
    errors.durationMinutes = "negative_value_error";
  }

  if (state.durationParticipation) {
    if (isNaN(state.durationParticipation)) {
      errors.durationParticipation = "type_number_value_error";
    } else if (Number(state.durationParticipation) < 0) {
      errors.durationParticipation = "negative_value_error";
    }
  }

  // — data inizio corso obbligatoria —
  if (!state.startDate) {
    errors.startDate = "required_completion_start_date";
  }

  //trasferta obbligatoria
  if (state.businessTrip === undefined || state.businessTrip === "") {
    errors.business_trip = "required_business_trip";
  }

  //ID Fonte
  if (!state.sourceId) {
    errors.sourceId = "required_source_id";
  }

  //Codice
  if (!state.code) {
    errors.code = "required_code";
  }

  // — data fine corso obbligatoria, ≥ inizio
  if (!state.endDate) {
    errors.endDate = "required_completion_end_date";
  } else {
    if (startDate && endDate! < startDate) {
      errors.endDate = "end_date_before_start_date";
    }
  }

  if (state.replacesPlatformCourse && !state.replacedCourse) {
    errors.replacedCourse = "required_replaced_course";
  }

  return errors;
};
